module.exports = __webpack_public_path__ + "static/media/infectious-and-parasitic-disease-icon.bd42899c.svg";